<template>
  <div class="main">
    <div class="logo">
      <img src="../assets/4med-ehr-logo-transparent.png" />
    </div>
    <div class="d-title">DIGITAL PRESCRIPTION</div>
    <div class="content-section">
      <div class="content-col">
        <div>Dr. L. Jarvis Smith, MD</div>
        <div>Provider #090812388</div>
        <div>PATIENT NAME: Pamela Barnes</div>
      </div>
      <div class="content-col">
        <div>Prescription #1467999</div>
        <div>{{ today }}</div>
        <div>DOB: 03-12-1983</div>
      </div>
    </div>
    <div class="script">
      <div><center>Acetaminophen 650mg</center></div>
      <div><center>Take one 650mg tablet by mouth every 4-6 hours</center></div>
    </div>
    <div class="footer">
      <div>
        {{ email }}
      </div>
      <div>
        <v-btn color="error" style="margin-right: 2vh" @click="closeWindow"
          >Close</v-btn
        >
        <v-btn color="primary" @click="printWindow">Print</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    console.log(this.$route.query.email);
    this.email = this.$route.query.email;
  },
  data() {
    return {
      today: "",
      email: "",
    };
  },
  mounted() {
    this.today = new Date().toLocaleDateString();
  },
  methods: {
    printWindow() {
      window.print();
    },
    closeWindow() {
      window.close();
    }
  },
};
</script>

<style>
.main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
}

img {
  height: 100px;
}

.d-title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
}

.content-section {
  display: flex;
  align-items: center;
  margin-top: 20px;
  font-size: 1.3rem;
  justify-content: center;
  font-weight: bold;
}

.content-col {
  margin-left: 10%;
  margin-right: 10%;
}

.script {
  margin-top: 20px;
  font-size: 1.3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.footer {
  position: absolute;
  bottom: 5vh;
  right: 5vh;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  flex-direction: column;
  align-items: flex-end;
}
</style>